import styled from 'styled-components';
import { fromLg, fromMd, fromXl, timingSlower, untilSm } from '../../constants';
import { skeletonAnimationCss } from '../Skeleton';
export const ResponsiveImage = styled.img `
  position: relative;
  width: 100%;
  max-width: 100%;
  object-fit: cover;

  background: ${o => o.$transparentBackground ? 'transparent' : o.theme.color.effect.skeleton.fill.on.background};

  ${untilSm} {
    ${props => props.$aspectRatioMd !== null ? `aspect-ratio: ${props.$aspectRatioXs};` : undefined}
  }
  ${props => (props.$aspectRatioSm !== null ? `aspect-ratio: ${props.$aspectRatioSm};` : undefined)}
  ${fromMd} {
    ${props => props.$aspectRatioMd !== null ? `aspect-ratio: ${props.$aspectRatioMd};` : undefined}
  }
  ${fromLg} {
    ${props => props.$aspectRatioLg !== null ? `aspect-ratio: ${props.$aspectRatioLg};` : undefined}
  }
  ${fromXl} {
    ${props => props.$aspectRatioXl !== null ? `aspect-ratio: ${props.$aspectRatioXl};` : undefined}
  }
`;
export const ResponsiveImageWrapper = styled.div `
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 100%;

  ${ResponsiveImage} {
    background: transparent;
  }
`;
export const ResponsiveImageSkeleton = styled.div `
  ${skeletonAnimationCss}

  position: absolute;
  inset: 0px;

  opacity: ${o => o.$hasLoaded && '0'};
  transition: opacity ${timingSlower} ease;
  animation-play-state: ${props => (props.$hasLoaded ? 'paused' : 'running')};

  &::after,
  &::before {
    animation-play-state: ${props => (props.$hasLoaded ? 'paused' : 'running')};
  }
`;
//# sourceMappingURL=styles.js.map